export const getCalendarDataForDay = (store, date) => {
    if (!store.calendar.calendarData.hasOwnProperty(date)) return {};
    return store.calendar.calendarData[date];
};

export const getRoomsForDay = (store, date) => {
    if (!store.calendar.roomIdsByDate.hasOwnProperty(date)) return {};

    const data = {};
    for (const roomId of store.calendar.roomIdsByDate[date]) data[roomId] = store.calendar.roomsById[roomId];
    return data;
};
